import i18n from '../../../../i18n'
import * as yup from 'yup'

export const AddDesignationSchema = yup.object().shape({
  designationInput: yup.string().required(`${i18n.t('FORMIK_ERROR.ADD_DESIGNATION.DESIGNATION_REQUIRED')}`),
  duty: yup.string().required(`${i18n.t('FORMIK_ERROR.ADD_DESIGNATION.DUTY_REQUIRED')}`),
  isDefault: yup.boolean()
})
